import { render, staticRenderFns } from "./tabs-tab.vue?vue&type=template&id=3650df1d&scoped=true&"
import script from "./tabs-tab.vue?vue&type=script&lang=js&"
export * from "./tabs-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650df1d",
  null
  
)

export default component.exports